import { useApi } from './useApi';

export const useSequence = (id, refreshData) => {
  const url =id;
  
  return useApi(url, [], refreshData);
};